/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Minutes_PlaceholderInputs */

const en_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes (MM)`)
};

const fr_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes (MM)`)
};

const de_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten (MM)`)
};

const it_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuti (MM)`)
};

const ru_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минуты (мм)`)
};

const es_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos (MM)`)
};

const zh_cn2_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟（MM）`)
};

const ja_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分（MM）`)
};

const hi_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिनट (MM)`)
};

const pt_pt2_subtitle_export_minutes_placeholder = /** @type {(inputs: Subtitle_Export_Minutes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos (MM)`)
};

/**
* | output |
* | --- |
* | "Minutes (MM)" |
*
* @param {Subtitle_Export_Minutes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_minutes_placeholder = /** @type {((inputs?: Subtitle_Export_Minutes_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Minutes_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_minutes_placeholder(inputs)
	if (locale === "de") return de_subtitle_export_minutes_placeholder(inputs)
	if (locale === "it") return it_subtitle_export_minutes_placeholder(inputs)
	if (locale === "ru") return ru_subtitle_export_minutes_placeholder(inputs)
	if (locale === "es") return es_subtitle_export_minutes_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_minutes_placeholder(inputs)
	if (locale === "ja") return ja_subtitle_export_minutes_placeholder(inputs)
	if (locale === "hi") return hi_subtitle_export_minutes_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_minutes_placeholder(inputs)
	return en_subtitle_export_minutes_placeholder(inputs)
});